import { axiosClient, getToken } from '../../Config/axiosConfig';

export const getConceptosBySearch = async (busqueda: string) => {
	await getToken();
	return await axiosClient.get(`/conceptos?busqueda=${busqueda}`);
};
